<template>
  <section>
    <b-card class="text-left">
      <b-row>
        <b-col lg="12" md="12" sm="12" xl="6">
          <div class=" text-secondary weight-bold">Study Info</div>
          <b-row class="mb-1">
            <b-col class="text-sm" sm="3"><strong>Title:</strong></b-col>
            <b-col class="infoText">{{ row['studyInfo']['title'] }}</b-col>
          </b-row>

          <b-row class="mb-1">
            <b-col class="text-sm" sm="3"><strong>Therapeutic Area:</strong></b-col>
            <b-col class="infoText">{{ row['studyInfo']['therapeyticArea'] }}</b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col class="text-sm" sm="3"><strong>Phase:</strong></b-col>
            <b-col class="infoText">{{ row['studyInfo']['developmentPhase'] }}</b-col>
          </b-row>
        </b-col>
      </b-row>
      <hr v-if="showForms" class="solid" />
      <b-row v-if="showForms">
        <b-col>
          <b-button
            v-for="form in row['formsInfo']"
            :key="form['eventID']"
            class="ml-2 mr-1"
            pill
            size="sm"
            variant="primary"
            @click="goToSiteSurvey(form['URL'])"
          >
            {{ form['formName'] }}
            <b-icon icon="box-arrow-up-right" scale="0.7"></b-icon>
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </section>
</template>
<script>
  export default {
    name: 'site-table-details',
    props: {
      row: {},
      isEnrollmentOversight: Boolean,
    },
    computed: {
      showForms() {
        if (!('formsInfo' in this.row)) {
          return false;
        }
        return this.row['formsInfo'].length > 0;
      },
    },
    methods: {
      roles(items) {
        let roles = [];
        items.forEach(element => {
          roles.push(element['role']);
        });
        return roles.join(', ');
      },
      goToSiteSurvey(url) {
        let domain = 'https://gsso-site-survey-staging.digitalpfizer.com/dashboard';
        if (window['Laravel'['env'] === 'production']) {
          domain = 'https://gsso.digitalpfizer.com/dashboard';
        }

        window.open(domain + url, '_blank');
      },
    },
  };
</script>

<style scoped>
  .infoText {
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #1c1b1e;
  }
</style>
